import {observer} from "mobx-react";
import {UIState} from "../../../data/UIState";
import * as moment from "moment-timezone";
import * as React from "react";

const LIMIT_MINUTES = 60;
const LIMIT_HOURS = 60*24;
const LIMIT_DAYS = 60*24*15;

export const Ago = observer( (props: { when: null|moment.Moment}) => {

  if(null===props.when) {
    return null;
  }

  let result = '';
  const minutesAgo = UIState.now.diff(moment(props.when), 'minute');
  if(0==minutesAgo) {
    result = 'just now';
  } else if(minutesAgo<LIMIT_MINUTES) {
    result = minutesAgo+'m';
  } else if(minutesAgo<LIMIT_HOURS) {
    result = Math.floor(minutesAgo/LIMIT_MINUTES)+'h';
  } else if(minutesAgo<LIMIT_DAYS) {
    result = Math.floor(minutesAgo/LIMIT_HOURS)+'d';
  } else if(props.when.get('year')===UIState.now.get('year')) {
    result = props.when.format("MMM D");
  } else {
    result = props.when.format("MMM D, YYYY");
  }

  return <span className={"ago"}>{result}</span>
});

